import { GET, POST } from '@/shared/api/requests';
import { ProjectSubscription } from '../types/subscription';

/**
 * Fetch all subscriptions for the current user's client
 */
export const getMySubscriptions = async (): Promise<ProjectSubscription[]> => {
  const response = await GET('subscriptions/my-subscriptions/');
  return response.data.subscriptions || [];
};

/**
 * Cancel a project subscription
 */
export const cancelSubscription = async (subscriptionId: number): Promise<void> => {
  await POST(`subscriptions/project/${subscriptionId}/cancel/`, {});
};

/**
 * Reactivate a cancelled subscription
 */
export const reactivateSubscription = async (subscriptionId: number): Promise<{ checkout_url: string }> => {
  const response = await POST(`subscriptions/project/${subscriptionId}/reactivate/`, {});
  return response.data;
};

/**
 * Update subscription plan
 */
export const updateSubscriptionPlan = async (
  subscriptionId: number,
  planId: number
): Promise<void> => {
  await POST(`subscriptions/project/${subscriptionId}/update/`, {
    plan_id: planId,
  });
};

/**
 * Get subscription details
 */
export const getSubscriptionDetail = async (subscriptionId: number): Promise<any> => {
  const response = await GET(`subscriptions/project/${subscriptionId}/`);
  return response.data;
};

